import { axiosPostWithoutEncryption, axiosGetFileAuthorizeblob } from '../AxiosRequests';
import { uploadPDF, GetFiles } from '../ApiEndPoints';

export default class CommonServices {

    async uploadPDF(request) {
        let formData = new FormData();
        formData.append("file", request.file);
        formData.append("filename", request.filename);
        formData.append("storagePath", request.storagePath);
        return axiosPostWithoutEncryption(uploadPDF, formData, true);
    }

    async getFiles(request) {
        return axiosGetFileAuthorizeblob(GetFiles, request);
    }

}